import { createSlice } from "@reduxjs/toolkit";
import { DISCOVER_TABS } from "../../utils/constants";
import { BUYER_REGISTRATION_STEPS } from "../../components/partials/property-details/right-panel/bidder-registration/constant";
const initialState = {
    tabData: {},
    isFetched: {},
    homeDiscoverLoading: false,
    activeTab: DISCOVER_TABS[0].key,
    runCount: 0,
    homeLiveAuction: [],
    homeLiveAuctionLoading: true,
    wonAuction: [],
    dislikedId: 0,
    calculator: {
        buyerType: "expat",
        price: 2400000,
        interest: 3.9,
        downPayment: 50,
        tenure: 15,
    },
    buyerPriceCalculator: {
        dataLoading: true,
        show: false,
        buyers_premium: null,
        platform_fees: null,
        taxes: null,
        total_price: null,
        current_bid: null,
        commission_amount: null,
        taxes: null,
        error: true,
    },
    buyerRegistration: {
        showForm: false,
        registration_id: null,
        step: BUYER_REGISTRATION_STEPS.DETAILS,
        loading: false,
        property_id: null,
        registrationType: null,
        formHasChanged: false,
        is_approved: null,
        seller_comment: null,
        self: {
            stepOneData: {
                cityList: [],
                stateList: [],
                state_name: "",
                country_name: "",
                issuing_country_code: "",
                completed: false,
                firstName: '',
                lastName: '',
                dob: null,
                nationality: null,
                phone: '',
                email: '',
                country: null,
                city: null,
                address_first: '',
                phone_country_code: "",
                lots: null,
                auction_session: null,
                isKycAvailable: false
            }
        },
        principal: {
            stepOneData: {
                completed: false,
                firstName: '',
                lastName: '',
                id_type: null,
                id_number: '',
                poa_expiry_date: null,
                phone: '',
                email: '',
                lots: null,
                auction_session: null
            },
            stepTwoData: {
                completed: false,
                principalIdDoc: null,
                powerOfAttorneyDoc: null
            }
        },
        state: "",
        community: "",
        community_ar: "",
        auction_start: null,
        selectedLots: [],
        // apiTotalDeposit:null,
        isBidderRegistrationModalOpen: false,
        reservation_agreement_accepted: false,
        agreementSigned: false,
        error: null,
    },
    privateAuctionDetails: {
        invitation_id: 0,
        auction_id: 0,
        property_id: 0,
        invitee_email: "",
        has_account: false,
        next_step: "",
        token: ""
    },
    quantaNoData: {
        noDataAreaComparison: false,
        noDataSaleTrends: false,
        noDataAveragePrice: false,
    }
};

export const buyerSlice = createSlice({
    name: "buyer",
    initialState,
    reducers: {
        setHomeDiscoverLoading: (state, { payload }) => {
            return {
                ...state,
                homeDiscoverLoading: payload,
            };
        },
        setTabData: (state, { payload }) => {
            const { tab, data } = payload;
            state.tabData[tab] = data;
            //commenting the below line because We want the data to reload on every click to prevent relying on previously fetched data.
            // state.isFetched[tab] = true;
        },
        setActiveTab: (state, { payload }) => {
            return {
                ...state,
                activeTab: payload,
            };
        },
        resetTabData: () => {
            return initialState;
        },
        toggleFavouriteStatus: (state, { payload }) => {
            const updatedTabData = state.tabData[state.activeTab]?.map(
                (ele) => ({
                    ...ele,
                    ...(ele.id === payload && {
                        is_favourite: !ele.is_favourite,
                    }),
                })
            );
            return {
                ...state,
                tabData: {
                    ...state.tabData,
                    [state.activeTab]: updatedTabData,
                },
            };
        },
        increamentRunCount: (state) => {
            state.runCount += 1;
        },
        setHomeLiveAucData: (state, { payload }) => {
            const { total, data } = payload;
            return {
                ...state,
                total,
                homeLiveAuction: data,
                homeLiveAuctionLoading: false,
            };
        },
        setWonAuctionData: (state, { payload }) => {
            return {
                ...state,
                wonAuction: payload,
            };
        },
        handleHomeLiveAucLoading: (state, { payload }) => {
            return {
                ...state,
                homeLiveAuctionLoading: payload,
            };
        },
        handleDislikedId: (state, { payload }) => {
            return {
                ...state,
                dislikedId: payload.id,
                ...(payload.data && {
                    wonAuction: {
                        ...state.wonAuction,
                        data: payload.data,
                    },
                }),
            };
        },
        setCalculatorField: (state, { payload = {} }) => {
            const { field, value } = payload;
            if (state.calculator.hasOwnProperty(field)) {
                state.calculator[field] = value;
            }
        },
        handleCalculateFinalPrice: (state, { payload }) => {
            return {
                ...state,
                buyerPriceCalculator: {
                    ...state.buyerPriceCalculator,
                    ...("show" in payload && {
                        show: payload.show,
                    }),
                    ...("dataLoading" in payload && {
                        dataLoading: payload.dataLoading,
                    }),
                    ...("buyers_premium" in payload && {
                        buyers_premium: payload.buyers_premium,
                    }),
                    ...("platform_fees" in payload && {
                        platform_fees: payload.platform_fees,
                    }),
                    ...("taxes" in payload && {
                        taxes: payload.taxes,
                    }),
                    ...("total_price" in payload && {
                        total_price: payload.total_price,
                    }),
                    ...("current_bid" in payload && {
                        current_bid: payload.current_bid,
                    }),
                    ...("commission_amount" in payload && {
                        commission_amount: payload.commission_amount,
                    }),
                    ...("taxes" in payload && {
                        taxes: payload.taxes,
                    }),
                    ...("error" in payload && {
                        error: payload.error,
                    }),
                    ...("reset" in payload && {
                        ...initialState.buyerPriceCalculator,
                    }),
                },
            };
        },
        updateBuyerRegistrationField: (state, action) => {
            const { section, stepKey, field, value } = action.payload;
            if (section && stepKey && value === null) {
                state.buyerRegistration[section][stepKey] = {
                    ...initialState.buyerRegistration[section][stepKey]
                };
            }
            else if (section && stepKey && field == null && typeof value === "object") {
                state.buyerRegistration[section][stepKey] = {
                    ...state.buyerRegistration[section][stepKey],
                    ...value,
                };
            }
            else if (!section && !stepKey && typeof value === 'object' && !field) {
                Object.assign(state.buyerRegistration, value);
            }
            else if (section && stepKey) {
                state.buyerRegistration[section][stepKey][field] = value;
            }
            else if (section) {
                state.buyerRegistration[section][field] = value;
            }
            else {
                state.buyerRegistration[field] = value;
            }
        },
        setPrincipalRegistrationDocument: (state, { payload }) => {
            const { operation, property, data } = payload;
            const docs = state.buyerRegistration.principal.stepTwoData;

            if (operation === "remove") {
                docs[property] = null;
            } else if (operation === "add" || operation === "update") {
                docs[property] = data;
            } else {
                // console.error("Invalid document operation:", operation);
                return;
            }
            docs.completed = false;
        },
        resetBuyerRegistration: (state) => {
            state.buyerRegistration = initialState.buyerRegistration;
        },
        handlePrivateAuctionDetails: (state, { payload }) => {
            return {
                ...state,
                privateAuctionDetails: {
                    ...state.privateAuctionDetails,
                    ...(payload?.reset ? initialState?.privateAuctionDetails : payload)

                },
            };
        },
        handleNoQuantaData: (state, { payload }) => {
            return {
                ...state,
                quantaNoData: {
                    ...state.quantaNoData,
                    ...payload

                },
            };
        },
    }
});
export const {
    setHomeDiscoverLoading,
    toggleFavouriteStatus,
    setActiveTab,
    setTabData,
    resetTabData,
    increamentRunCount,
    setHomeLiveAucData,
    handleHomeLiveAucLoading,
    handleDislikedId,
    setCalculatorField,
    handleCalculateFinalPrice,
    updateBuyerRegistrationField,
    resetBuyerRegistration,
    setPrincipalRegistrationDocument,
    handlePrivateAuctionDetails,
    handleNoQuantaData
} = buyerSlice.actions;
export default buyerSlice;
